<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <div class="input-group">
              <input
                type="text"
                id="search-sources"
                aria-label="SearchSources"
                aria-describedby="SearchSources"
                placeholder="Search time zones"
                class="form-control mr-2"
                v-model="searchWord"
                @input="onSearchInput"
              />
            </div>
            <button
              type="button"
              class="ml-auto btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#addCampaignModal"
            >
              Add Time Zone
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="d-flex align-items-center">Description</div>
                  </th>
                  <th scope="col">
                    <div class="d-flex align-items-center">Time zone</div>
                  </th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="(timezone, index) in filteredTimeZones" :key="index">
                  <th scope="row">
                    <div class="d-flex align-items-center">{{ timezone.time_zone }}</div>
                  </th>
                  <th scope="row">
                    <div class="d-flex align-items-center">{{ timezone.utc_timezone }}</div>
                  </th>
                  <th>
                    <button @click="handleEditClick(timezone)" class="btn btn-link">
                      <i
                        style="font-size: 16px;
          color: #666; cursor:pointer"
                        class="fas fa-pencil-alt"
                      ></i>
                    </button>
                    <button class="btn btn-link" @click="handleDeleteClick(timezone)">
                      <svgHelper name="delete"></svgHelper>
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />

    <div
      class="modal fade add-user-modal"
      id="editCampaignModal"
      tabindex="-1"
      aria-labelledby="editCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">Edit Time Zone</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeEdit"
              @click="resetModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input
                    disabled
                    id="editNameTz"
                    type="text"
                    class="form-control"
                    v-model="editTimeZone.utc_timezone"
                  />
                  <label for="editNameTz">Time zone</label>
                </div>
                <div class="form-group m-label-left">
                  <input
                    id="editName"
                    type="text"
                    class="form-control"
                    v-model="editTimeZone.time_zone"
                  />
                  <label for="editName">Description</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="updateTimeZone()" type="button" class="btn btn-primary">
              Save
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addCampaignModal"
      tabindex="-1"
      aria-labelledby="addCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addCampaignModalTitle">Add Time Zone</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeAdd"
              @click="resetModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input
                    id="addCampaignid"
                    type="text"
                    class="form-control"
                    v-model="addNewTimeZone"
                  />
                  <label for="addCampaignid">Time zone</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="addTimeZone()" type="button" class="btn btn-primary">
              Save
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="deleteCampaignModal"
      tabindex="-1"
      aria-labelledby="deleteCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteCampaignModalTitle">Delete Time Zone</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p class="text-center">
                  Please confirm that you want to delete the selected time zone.
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deleteTimeZone()" type="button" class="btn btn-primary">
              Delete
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'Time zones | Jobshark';
  },
  /*   description() {
    return 'Page description goes here.';
  }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/campaigns';
  },
  components: {},
  data: () => ({
    isLoading: false,
    searchWord: '',
    timeZones: [],
    editTimeZone: {},
    addNewTimeZone: '',
  }),
  methods: {
    getTimeZones() {
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: {
          page: 1,
          count: 10000,
          search_word: '',
        },
        headers: {
          /*           Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`, */
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.timeZones = res.data.data;
      });
    },

    resetModal() {
      this.addNewTimeZone = '';
    },

    setForEdit(tz) {
      this.editTimeZone = { ...tz };
    },

    updateTimeZone() {
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/update`, {
        method: 'post',
        data: {
          time_zone_id: this.editTimeZone.id,
          time_zone: this.editTimeZone.time_zone,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.getTimeZones();
          this.$refs.closeEdit.click();
        })
        .catch(err => {
          this.$toasted.error('Invalid time zone', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    deleteTimeZone() {
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/delete`, {
        method: 'delete',
        data: {
          time_zone_id: this.editTimeZone.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.getTimeZones();
        this.$toasted.success('Time zoned deleted', {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
        this.$refs.closeDelete.click();
      });
    },
    addTimeZone() {
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/create`, {
        method: 'post',
        data: {
          time_zone: this.addNewTimeZone,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.getTimeZones();
          this.$toasted.success('Time zone added', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          this.$refs.closeAdd.click();
        })
        .catch(err => {
          console.log(err.response);
          if (err.response.data === 'Existing timezone') {
            this.$toasted.error('Time zone already exists', {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          } else {
            this.$toasted.error('Invalid time zone', {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          }
        });
    },

    handleEditClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let editModal = new bootstrap.Modal(document.getElementById('editCampaignModal'));
        editModal.show();
      });
    },

    handleDeleteClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let deleteModal = new bootstrap.Modal(document.getElementById('deleteCampaignModal'));
        deleteModal.show();
      });
    },
    onSearchInput(e) {
      this.searchWord = e.target.value;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    filteredTimeZones() {
      const term = this.searchWord.trim().toLowerCase();
      if (!term) return this.timeZones;

      return this.timeZones.filter(tz => {
        // match either the description or the UTC code
        return (
          tz.time_zone.toLowerCase().includes(term) || tz.utc_timezone.toLowerCase().includes(term)
        );
      });
    },
  },
  mounted() {
    this.getTimeZones();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: right;
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
